



const DivTrailer = (props) => {

    return (<div className="video-responsive">
        <iframe src={props.trailer} title={props.title} allowFullScreen />
    </div>
    )
}

export default DivTrailer